import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Button, Modal } from "react-bootstrap";
import swal from "sweetalert";
import { object, string } from "yup";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { getLocations } from "../../../services/JobsService";
import MultiSelect from "./Jobs/MultiSelect";
import { uploadFile } from "../../../services/CommonService";
import { getAllIdentity, getAllSkills } from "../../api/common";
import {
  addJobFair,
  deleteJobFair,
  getJobFair,
  getJobFairList,
  updateJobFair,
} from "../../../services/JobFairService";

let jobSchema = object().shape({
  title: string().required({ title: "Job title is required." }),
  //   location: string().required({ location: "Location is required." }),
  //   identity: string().required({ identity: "Identity is required." }),
  //   qualification: string().required({
  //     qualification: "Qualification is required.",
  //   }),
  //   experience: string().required({
  //     experience: "Minimum experience is required.",
  //   }),
  expiry_date: string().required({
    expiry_date: "Expiry date is required.",
  }),
  banner: string().required({ banner: "Image is required." }),
});

let jobUpdateSchema = object().shape({
  title: string().required({ title: "Job title is required." }),
  //   location: string().required({ location: "Location is required." }),
  //   identity: string().required({ identity: "Identity is required." }),
  //   qualification: string().required({
  //     qualification: "Qualification is required.",
  //   }),
  //   experience: string().required({
  //     experience: "Minimum experience is required.",
  //   }),
  expiry_date: string().required({
    expiry_date: "Expiry date is required.",
  }),
  //banner: string().required({ banner: "Image is required." }),
});

function ManageJobFair() {
  const optionCount = 61;
  const inputs = useMemo(() => {
    return {
      title: "",
      is_live: 0,
      banner: "",
      location: "",
      identity: "",
      qualification: "",
      experience: "",
      experience_min: "",
      experience_max: "",
      skills: "",
      expiry_date: new Date(),
    };
  }, []);

  //   const [searchParams] = useSearchParams();
  //   const rid = searchParams.get("rid");

  const [addModel, setAddModal] = useState(false);
  const [updateModel, setUpdateModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRow, setSelectedRows] = useState([]);
  const [errors, setError] = useState({});
  const [inputData, setInputData] = useState(inputs);
  const [editData, setEditData] = useState(inputs);

  const [identities, setIdentities] = useState([]);
  const [selectedidentities, setSelectedIdentities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [skills, setSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [imageUploading, setImageUploading] = useState({
    uploding: false,
    name: null,
  });

  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
    keyword: "",
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      setToggleCleared(!toggleCleared);
      setLoading(true);
      getJobFairList(params)
        .then((res) => {
          setData(res?.data?.data);
          setTotalRows(res?.data?.totalRecords);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          //console.log(err);
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams]);

  const formatOptionList = useCallback((res, label, value, callback) => {
    if (res.length > 0) {
      let optionArray = [];
      optionArray.push({ value: "", label: "All" });
      res.forEach((obj, i) => {
        optionArray.push({ value: obj[value], label: obj[label] });
      });
      if(label=="identify_name"){
        optionArray.push({ value: "16", label: "Women" });
        optionArray.push({ value: "15", label: "Men" });
      }
      callback(optionArray);
    }
  }, []);

  const fetchPageData = useCallback(() => {
    getLocations()
      .then((res) => {
        formatOptionList(res?.data?.data, "city_name", "id", setLocations);
      })
      .catch((err) => {
        console.log("Fetch Location error " + err.message);
      });
    getAllIdentity()
      .then((res) => {
        formatOptionList(res, "identify_name", "id", setIdentities);
      })
      .catch((err) => {
        console.log("Fetch Location error " + err.message);
      });

    getAllSkills()
      .then((res) => {
        formatOptionList(res, "skill_title", "id", setSkills);
      })
      .catch((err) => {
        console.log("Fetch Location error " + err.message);
      });
  }, [formatOptionList, setLocations, setIdentities, setSkills]);

  useEffect(() => {
    fetchPageData();
  }, [fetchPageData]);

  const setSelectedValues = useCallback((value, states, setSelectedFun) => {
    if (value) {
      let valueArray = value.split(",");
      if (valueArray?.length > 0) {
        let selectedArray = states.filter((ele, i) => {
          return valueArray.includes(String(ele?.value));
        });
        setSelectedFun(selectedArray);
      }
    }
  }, []);

  const onEdit = useCallback(
    (row) => {
      setError({});
      getJobFair(row?.id)
        .then((res) => {
          if (res.data?.data?.id) {
            setSelectedValues(
              res.data?.data?.location,
              locations,
              setSelectedLocations
            );

            setSelectedValues(
              res.data?.data?.identity,
              identities,
              setSelectedIdentities
            );

            setSelectedValues(
              res.data?.data?.skills,
              skills,
              setSelectedSkills
            );

            let editIp = {
              id: res.data?.data?.id,
              title: res.data?.data?.title,
              experience_min: res.data?.data?.experience,
              experience_max: res.data?.data?.max_experience,
              skills: res.data?.data?.skills,
              identity: res.data?.data?.identity,
              location: res.data?.data?.location,
              is_live: res.data?.data?.is_live,
              qualification: res.data?.data?.qualification,
              expiry_date: res.data?.data?.expiry_date,
              banner: res.data?.data?.banner,
            };
            setEditData(editIp);
            setInputData(editIp);
            setUpdateModal(true);
          } else {
            console.log(res?.data);
          }
        })
        .catch((err) => console.log(err));
    },
    [
      setEditData,
      setError,
      locations,
      setSelectedValues,
      identities,
      setInputData,
    ]
  );

  const onDelete = useCallback(
    (row) => {
      swal({
        title: "Are you sure?",
        text: "Are you sure that you want to delete this record?",
        icon: "warning",
        dangerMode: true,
        buttons: true,
      }).then((res) => {
        if (res) {
          deleteJobFair(row?.id).then((res) => {
            setFetch(true);
            swal("Deleted!", res.data.message, "success");
          });
        }
      });
    },
    [setFetch]
  );

  const columns = useMemo(
    () => [
      {
        name: "Fair Code",
        selector: (row) => row.id,
        sortable: true,
        sortField: "id",
      },
      {
        name: "Actions",
        button: "true",
        width: "150px",
        cell: (row) => {
          return (
            <>
              <Link
                className="btn btn-secondary btn-sm light me-2"
                to={`/job-fair-verification?fid=${row.id}`}
                //onClick={(e) => handleApplicantsClick(e, row.id)}
              >
                <i className="fa fa-users"></i>
              </Link>
              <button
                className="btn btn-sm btn-outline-warning me-2"
                onClick={() => onEdit(row)}
              >
                <i className="fa fa-edit"></i>
              </button>
              <button
                className="btn btn-sm btn-outline-danger"
                onClick={() => onDelete(row)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </>
          );
        },
      },
      {
        name: "Is live",
        selector: (row) =>
          row.is_live === 0 ? "No" : row.is_live === 1 ? "Yes" : "Inactive",
        sortable: true,
        sortField: "is_live",
      },
      {
        name: "Title",
        selector: (row) => row.title,
        width: "150px",
        wrap: true,
        sortable: true,
        sortField: "title",
      },
      {
        name: "Locations",
        selector: (row) => row.location,
        width: "150px",
        sortable: false,
        wrap: true,
        sortField: "location",
      },
      {
        name: "Identities",
        selector: (row) => row.identity,
        width: "150px",
        sortable: false,
        wrap: true,
        sortField: "identity",
      },
      {
        name: "Qualification",
        selector: (row) => row.qualification,
        width: "150px",
        sortable: true,
        wrap: true,
        sortField: "qualification",
      },
      {
        name: "Min. Experience",
        selector: (row) => row.experience,
        width: "142px",
        sortable: true,
        sortField: "experience",
      },
      {
        name: "Max. Experience",
        selector: (row) => row.max_experience,
        width: "145px",
        sortable: true,
        sortField: "max_experience",
      },
      {
        name: "Skills",
        selector: (row) => row.skills,
        width: "150px",
        sortable: true,
        sortField: "skills",
      },
      {
        name: "Expiry date",
        width: "150px",
        selector: (row) => row.expiry_date,
        sortable: true,
        sortField: "expiry_date",
      },
    ],
    [onEdit]
  );

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleAdd = useCallback(
    (e) => {
      e.preventDefault();
      let fInputData = { ...inputData };
      jobSchema
        .validate(fInputData, { strict: false, abortEarly: false })
        .then((resp) => {
          resp = {
            ...resp,
            expiry_date: moment(resp?.expiry_date).format("yyyy-MM-DD"),
          };
          setError({});
          addJobFair(resp)
            .then((response) => {
              setInputData(inputs);
              e.target.reset();
              setAddModal(false);
              swal("Great Job!", response?.data.message, "success");
              setFetch(true);
            })
            .catch((e) => console.log(e));
        })
        .catch((err) => {
          let errObj = {};
          err.errors.map((msg, i) => {
            let keys = Object.keys(msg);
            if (errObj[keys[0]] === undefined) {
              errObj = { ...errObj, [keys[0]]: msg[keys[0]] };
            }
            return false;
          });
          setError(errObj);
        });
    },
    [setFetch, inputs, inputData]
  );

  const handleUpdate = useCallback(
    (e) => {
      e.preventDefault();
      jobUpdateSchema
        .validate(inputData, { strict: false, abortEarly: false })
        .then((resp) => {
          resp = {
            ...resp,
            expiry_date: moment(resp?.expiry_date).format("yyyy-MM-DD"),
          };

          setError({});
          updateJobFair(inputData?.id, resp)
            .then((response) => {
              setEditData(inputs);
              setInputData(inputs);
              setUpdateModal(false);
              swal("Great Job!", response?.data.message, "success");
              setFetch(true);
            })
            .catch((e) => console.log(e));
        })
        .catch((err) => {
          let errObj = {};
          err?.errors?.map((msg, i) => {
            let keys = Object.keys(msg);
            if (errObj[keys[0]] === undefined) {
              errObj = { ...errObj, [keys[0]]: msg[keys[0]] };
            }
            return false;
          });
          setError(errObj);
        });
    },
    [setFetch, inputs, setInputData, inputData]
  );

  const selectOptions = useCallback(() => {
    let options = [];
    for (let index = 0; index < optionCount; index++) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  }, [optionCount]);

  const handleUploadImage = useCallback(
    (file) => {
      setImageUploading({ uploding: true, name: null });
      uploadFile(file, "fair")
        .then((res) => {
          if (res.data?.data) {
            setInputData({
              ...inputData,
              banner: res.data?.data,
            });
          } else {
            console.log(res.data?.error);
          }
          setImageUploading({ uploding: false, name: null });
        })
        .catch((err) => {
          console.log(err);
          setImageUploading({ uploding: false, name: null });
        });
    },
    [inputData, setInputData, setImageUploading]
  );

  const handleMultiSelect = useCallback(
    (values, inputname) => {
      if (values?.length > 0) {
        let ids = [];
        values.forEach((element, i) => {
          ids.push(element?.value);
        });
        setInputData({
          ...inputData,
          [inputname]: ids.toString(),
        });
      } else if (values?.value) {
        setInputData({ ...inputData, [inputname]: values.value.toString() });
      } else {
        setInputData({ ...inputData, [inputname]: "" });
      }
    },
    [inputData, setInputData]
  );

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      let errorHtml = Object.keys(errors).map((k, i) => {
        if (errors[k] === "j" || errors[k] === "J") return null;
        return `<li>${errors[k]}</li>`;
      });
      var ul = document.createElement("ul");
      ul.innerHTML = errorHtml.join("");
      swal({
        title: "Input validation error!",
        icon: "error",
        content: ul,
      });
    }
  }, [errors]);

  useEffect(() => {
    if (!updateModel) {
      setInputData(inputs);
    }
  }, [updateModel, setInputData, inputs]);

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const handleExtraFilter = useCallback(
    (filter) => {
      setReqParams({ ...reqParams, ...filter });
      setFetch(true);
    },
    [reqParams, setReqParams, setFetch]
  );

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600  me-auto"></h4>
        <div>
          <Link to={"#"} onClick={() => setAddModal(true)}>
            <button className="btn btn-info me-3 btn-sm">
              <i className="fas fa-plus-circle me-1"> </i>New Event
            </button>
          </Link>
          {/* <button
            onClick={() => handleChangeStatus(1)}
            className="btn btn-warning me-3 btn-sm"
          >
            <i className="fas fa-thumbs-up me-1"> </i>Activate Jobs
          </button>

          <button
            onClick={() => handleChangeStatus(0)}
            className="btn btn-danger me-3 btn-sm"
          >
            <i className="fas fa-thumbs-down me-1"> </i>Inactivate Jobs
          </button> */}
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              //selectableRows
              persistTableHead
              clearSelectedRows={toggleCleared}
              //conditionalRowStyles={rowStyle}
              //   onSelectedRowsChange={({ selectedRows }) => {
              //     //console.log(selectedRows)
              //     setSelectedRows(selectedRows);
              //   }}
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
      <Modal
        className="modal fade"
        size="lg"
        show={addModel}
        onHide={setAddModal}
        keyboard={false}
        backdrop="static"
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Create Event</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setAddModal(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <form onSubmit={handleAdd}>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="add-contact-box">
                      <div className="add-contact-content">
                        <div className="mb-3 form-group">
                          <label htmlFor="title">
                            Title<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="title"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                title: e.target.value,
                              })
                            }
                            className="form-control"
                            type="text"
                            name="title"
                            required=""
                          />
                          {errors?.title !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.title}
                            </div>
                          )}
                        </div>

                        {/* <div className="mb-3 form-group">
                          <label>Experience</label>

                          <select
                            id="experience"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                experience: e.target.value,
                              })
                            }
                            className="form-select"
                            name="experience"
                          >
                            <option value="">Select experience</option>
                            {selectOptions()}
                          </select>
                          {errors?.experience !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.experience}
                            </div>
                          )}
                        </div> */}
                        <div className="row mb-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="formGroupExampleInput">
                                Experience min
                              </label>
                              <div className="input-group mb-1 form-group">
                                <select
                                  id="experience_min"
                                  className="form-select"
                                  type="text"
                                  name="experience_min"
                                  onChange={(e) =>
                                    setInputData({
                                      ...inputData,
                                      experience_min: e.target.value,
                                    })
                                  }
                                  defaultValue={inputData?.experience_min}
                                >
                                  <option value="">Please Select</option>
                                  {selectOptions()}
                                </select>
                                <span
                                  className="input-group-text"
                                  id="basic-addon1"
                                >
                                  Years
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="formGroupExampleInput">
                                Experience max
                              </label>
                              <div className="input-group mb-1 form-group">
                                <select
                                  id="experience_max"
                                  className="form-select"
                                  type="text"
                                  name="experience_max"
                                  onChange={(e) =>
                                    setInputData({
                                      ...inputData,
                                      experience_max: e.target.value,
                                    })
                                  }
                                  defaultValue={inputData?.experience_max}
                                >
                                  <option value="">Please Select</option>
                                  {selectOptions()}
                                </select>
                                <span
                                  className="input-group-text"
                                  id="basic-addon1"
                                >
                                  Years
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3 form-group">
                          <label>Qualification </label>

                          {/*<select
                            id="qualification"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                qualification: e.target.value,
                              })
                            }
                            className="form-select"
                            name="qualification"
                          >
                            <option value="">Select Highest Education</option>
                            <option value="Below 10th">Below 10th</option>
                            <option value="10th">10th</option>
                            <option value="12th">12th</option>
                            <option value="Diploma">Diploma</option>
                            <option value="Graduation">Graduation</option>
                            <option value="Post Graduation">
                              Post Graduation
                            </option>
                            <option value="Doctorate">Doctorate</option>
                          </select>*/}

                          <input
                            id="qualification"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                qualification: e.target.value,
                              })
                            }
                            className="form-control"
                            type="text"
                            name="qualification"
                            required=""
                          />
                          {errors?.qualification !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.qualification}
                            </div>
                          )}
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="locations">Locations</label>
                          <MultiSelect
                            create={false}
                            multiple={true}
                            options={locations}
                            onValueSelect={handleMultiSelect}
                            name="location"
                          />
                          {errors?.location !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.location}
                            </div>
                          )}
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="loc">Select Identities</label>
                          <MultiSelect
                            create={false}
                            multiple={true}
                            options={identities}
                            onValueSelect={handleMultiSelect}
                            name="identity"
                          />
                          {errors?.identity !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.identity}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="skills">Skills</label>
                          <div className="mb-3 form-group">
                            <MultiSelect
                              create={false}
                              multiple={true}
                              options={skills}
                              onValueSelect={handleMultiSelect}
                              name="skills"
                            />
                          </div>
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="expiry_date">Expiry Date</label>
                          <div className="form-group">
                            <DatePicker
                              wrapperClassName={"dp-full-width"}
                              id="expiry_date"
                              selected={
                                inputData?.expiry_date
                                  ? new Date(inputData?.expiry_date)
                                  : new Date()
                              }
                              onChange={(date) =>
                                setInputData({
                                  ...inputData,
                                  expiry_date: date ? date : "",
                                })
                              }
                              name="expiry_date"
                              className="form-control"
                              dateFormat="Y-MM-dd"
                              minDate={new Date()}
                            />
                          </div>
                          {errors?.expiry_date !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.expiry_date}
                            </div>
                          )}
                        </div>
                        <div className="mb-3 form-group">
                          <label htmlFor="banner">
                            Upload Fair banner
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="banner"
                            onChange={(e) =>
                              handleUploadImage(e.target.files[0])
                            }
                            className="form-control"
                            type="file"
                            name="banner"
                            required=""
                          />
                          {imageUploading.uploding && (
                            <span className="text-warning">
                              Image uploading...
                            </span>
                          )}
                          {errors?.banner !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.banner}
                            </div>
                          )}
                        </div>
                        <div className="mb-3 form-group">
                          <label htmlFor="is_live" className="me-3">
                            Is Live<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              //value=""
                              id="no"
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  is_live: 0,
                                })
                              }
                              name="is_live"
                              defaultChecked={true}
                            />
                            <label className="form-check-label" htmlFor="no">
                              No
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  is_live: 1,
                                })
                              }
                              id="yes"
                              name="is_live"
                            />
                            <label className="form-check-label" htmlFor="yes">
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  is_live: 2,
                                })
                              }
                              id="inactive"
                              name="is_live"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inactive"
                            >
                              Inactive
                            </label>
                          </div>
                          {errors?.is_live !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.is_live}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <div>
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    disabled={imageUploading.uploding}
                  >
                    <i className="fa fa-save"></i> Save
                  </button>
                  <button
                    type="button"
                    onClick={() => setAddModal(false)}
                    className="btn btn-danger"
                  >
                    <i className="fa fa-times"></i> Close
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <Modal
        className="modal fade"
        size="lg"
        show={updateModel}
        onHide={setUpdateModal}
        keyboard={false}
        backdrop="static"
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Update Event</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setUpdateModal(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <form onSubmit={handleUpdate}>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="add-contact-box">
                      <div className="add-contact-content">
                        <div className="mb-3 form-group">
                          <label htmlFor="title">
                            Title<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="title"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                title: e.target.value,
                              })
                            }
                            className="form-control"
                            defaultValue={editData?.title}
                            type="text"
                            name="title"
                            required=""
                          />
                          {errors?.title !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.title}
                            </div>
                          )}
                        </div>

                        {/* <div className="mb-3 form-group">
                          <label>
                            Experience <span style={{ color: "red" }}>*</span>
                          </label>

                          <select
                            id="experience"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                experience: e.target.value,
                              })
                            }
                            className="form-select"
                            defaultValue={editData?.experience}
                            type="text"
                            name="experience"
                          >
                            {selectOptions()}
                          </select>
                          {errors?.experience !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.experience}
                            </div>
                          )}
                        </div> */}

                        <div className="row mb-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="formGroupExampleInput">
                                Experience min
                              </label>
                              <div className="input-group mb-1 form-group">
                                <select
                                  id="experience_min"
                                  className="form-select"
                                  type="text"
                                  defaultValue={editData?.experience_min}
                                  name="experience_min"
                                  onChange={(e) =>
                                    setInputData({
                                      ...inputData,
                                      experience_min: e.target.value,
                                    })
                                  }
                                >
                                  <option value="">Please Select</option>
                                  {selectOptions()}
                                </select>
                                <span
                                  className="input-group-text"
                                  id="basic-addon1"
                                >
                                  Years
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="formGroupExampleInput">
                                Experience max
                              </label>
                              <div className="input-group mb-1 form-group">
                                <select
                                  id="experience_max"
                                  className="form-select"
                                  type="text"
                                  name="experience_max"
                                  onChange={(e) =>
                                    setInputData({
                                      ...inputData,
                                      experience_max: e.target.value,
                                    })
                                  }
                                  defaultValue={editData?.experience_max}
                                >
                                  <option value="">Please Select</option>
                                  {selectOptions()}
                                </select>
                                <span
                                  className="input-group-text"
                                  id="basic-addon1"
                                >
                                  Years
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="mb-3 form-group">
                          <label>
                            Qualification{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <input
                            id="qualification"
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                qualification: e.target.value,
                              })
                            }
                            className="form-control"
                            defaultValue={editData?.qualification}
                            type="text"
                            name="qualification"
                            required=""
                          />

                          {errors?.qualification !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.qualification}
                            </div>
                          )}
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="location">
                            Locations<span style={{ color: "red" }}>*</span>{" "}
                          </label>
                          <MultiSelect
                            create={false}
                            multiple={true}
                            options={locations}
                            onValueSelect={handleMultiSelect}
                            name="location"
                            selected={selectedLocations}
                          />
                          {errors?.location !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.location}
                            </div>
                          )}
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="loc">
                            Select Identities
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <MultiSelect
                            create={false}
                            multiple={true}
                            options={identities}
                            onValueSelect={handleMultiSelect}
                            name="identity"
                            selected={selectedidentities}
                          />
                          {errors?.identity !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.identity}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="skills">Skills</label>
                          <div className="mb-3 form-group">
                            <MultiSelect
                              create={false}
                              multiple={true}
                              options={skills}
                              onValueSelect={handleMultiSelect}
                              name="skills"
                              selected={selectedSkills}
                            />
                          </div>
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="expiry_date">
                            Expiry Date
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="form-group">
                            <DatePicker
                              wrapperClassName={"dp-full-width"}
                              id="expiry_date"
                              selected={
                                inputData?.expiry_date !== "0000-00-00"
                                  ? new Date(inputData?.expiry_date)
                                  : new Date()
                              }
                              onChange={(date) =>
                                setInputData({
                                  ...inputData,
                                  expiry_date: date ? date : "",
                                })
                              }
                              name="expiry_date"
                              className="form-control"
                              dateFormat="Y-MM-dd"
                              minDate={new Date()}
                            />
                          </div>
                          {errors?.expiry_date !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.expiry_date}
                            </div>
                          )}
                        </div>
                        <div className="mb-3 form-group">
                          <label htmlFor="banner">
                            Upload Fair banner
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            id="banner"
                            onChange={(e) =>
                              handleUploadImage(e.target.files[0])
                            }
                            className="form-control"
                            type="file"
                            name="banner"
                            required=""
                          />
                          {imageUploading.uploding && (
                            <span className="text-warning">
                              Image uploading...
                            </span>
                          )}
                          {errors?.banner !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.banner}
                            </div>
                          )}
                        </div>

                        <div className="mb-3 form-group">
                          <label htmlFor="is_live" className="me-3">
                            Is Live<span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              //value=""
                              id="no"
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  is_live: 0,
                                })
                              }
                              name="is_live"
                              defaultChecked={
                                editData?.is_live === 0 ? true : false
                              }
                            />
                            <label className="form-check-label" htmlFor="no">
                              No
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  is_live: 1,
                                })
                              }
                              id="yes"
                              name="is_live"
                              defaultChecked={
                                editData?.is_live === 1 ? true : false
                              }
                            />
                            <label className="form-check-label" htmlFor="yes">
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  is_live: 2,
                                })
                              }
                              id="inactive"
                              name="is_live"
                              defaultChecked={
                                editData?.is_live === 2 ? true : false
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inactive"
                            >
                              Inactive
                            </label>
                          </div>
                          {errors?.is_live !== undefined && (
                            <div className="invalid-feedback d-block">
                              {errors?.is_live}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <div>
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    disabled={imageUploading.uploding}
                  >
                    <i className="fa fa-save"></i> Update
                  </button>
                  <button
                    type="button"
                    onClick={() => setUpdateModal(false)}
                    className="btn btn-danger"
                  >
                    <i className="fa fa-times"></i> Close
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ManageJobFair;
